import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
// import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF";
// import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
// import { faAngellist } from "@fortawesome/free-brands-svg-icons/faAngellist";
// import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'mailto:piyushdattaca@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
  {
    link: 'https://www.linkedin.com/in/piyushdatta',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://github.com/PiyushDatta',
    label: 'Github',
    icon: faGithub,
  },
  // {
  //   link: 'https://facebook.com/',
  //   label: 'Facebook',
  //   icon: faFacebook,
  // },
  // {
  //   link: 'https://www.instagram.com/',
  //   label: 'Instagram',
  //   icon: faInstagram,
  // },
  // {
  //   link: 'https://angel.co/',
  //   label: 'Angel List',
  //   icon: faAngellist,
  // },
  // {
  //   link: 'https://twitter.com/',
  //   label: 'Twitter',
  //   icon: faTwitter,
  // },
];

export default data;
